import { render, staticRenderFns } from "./DisconnectIcon.vue?vue&type=template&id=c490324c&"
import script from "./DisconnectIcon.vue?vue&type=script&lang=js&"
export * from "./DisconnectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports